import { useTranslate } from '@festina-life/ui/hooks'
import * as Yup from 'yup'

export const useBranchTypesValidationSchema = () => {
  const translate = useTranslate()

  return Yup.object({
    typesVersionName: Yup.string().required(translate('validation.required')),
    typesVersionDescription: Yup.string().required(
      translate('validation.required'),
    ),
    typeVersionFile: Yup.array()
      .required(translate('validation.required'))
      .test(
        'file_selected',
        translate('branchTypes.validation.file.empty'),
        (value: File[]) => value?.length === 1,
      ),
  })
}
